import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

const ServiceKdsPage = () => {
  const [isVisible, setIsVisible] = useState<boolean[]>([false]);

  // text 애니메이션
  const hideRefs = [
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      hideRefs.forEach((ref, index) => {
        const element = ref.current;
        if (element) {
          const elementTop = element.offsetTop;
          const elementHeight = element.offsetHeight;
          const isElementVisible =
            scrollTop + windowHeight > elementTop &&
            scrollTop < elementTop + elementHeight;
          setIsVisible((prev) => {
            const newVisible = [...prev];
            newVisible[index] = isElementVisible;
            return newVisible;
          });
        }
      });

      if (scrollTop + windowHeight === documentHeight) {
        setIsVisible((prev) => {
          const newVisible = [...prev];
          newVisible[newVisible.length - 1] = true;
          return newVisible;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Style>
      <div className="wrap">
        <div className="bannerTitle mobileView">
          <h1
            ref={hideRefs[6]}
            className={` ${isVisible[6] ? "in_view fade_in" : "fade_in"}`}
          >
            KDS
          </h1>
          <h2>
            주문서 인쇄는 이제 그만!
            <br />
            이벤 효율적으로 운영하세요.
          </h2>
        </div>
        <div className="banner">
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKdsImage01.png"
            alt="주문서인쇄는 그만! 효율적인 매장 운영이 가능한 kds"
            className="webKds01"
          />
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKdsImage01-kds.png"
            alt="kds"
            className="behindKds webView"
          />
        </div>
        <div className="contentWrap">
          <div className="content">
            <h1
              ref={hideRefs[0]}
              className={` ${isVisible[0] ? "in_view fade_up" : "fade_up"}`}
            >
              효율적인 주문 관리
            </h1>
            <h2>
              주문이 완료되면 즉시 주방에 전달되어 종이 주문서가 필요없고,
              <br />
              주문 전달 과정이 빨라집니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKdsImage02.png"
              alt="효율적인 주문 관리가 가능한 kds"
              className="webKds02"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[1]}
              className={` ${isVisible[1] ? "in_view fade_up" : "fade_up"}`}
            >
              카톡 ,DID 호출 가능
            </h1>
            <h2>
              픽업 준비가 완료되면 카카오톡으로 알림이 가고,
              <br />
              DID 화면에 표시됩니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKdsImage03.png"
              alt="카카오톡 호출, DID 연동이 가능한 kds"
              className="webKds03"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[2]}
              className={` ${isVisible[2] ? "in_view fade_up" : "fade_up"}`}
            >
              통합 시스템과의 연동
            </h1>
            <h2 style={{ whiteSpace: "nowrap" }}>
              POS 시스템과 쉽게 통합되어,
              <br />
              주문이 한 번 입력되면 자동으로 주방으로 전달됩니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKdsImage04.png"
              alt="주문이 자동으로 KDS에 접수되는 비하인드 KDS"
              className="webKds04"
            />
          </div>
          <div className="content">
            <div
              ref={hideRefs[3]}
              className={` ${
                isVisible[3] ? "title in_view fade_up" : "title fade_up"
              }`}
            >
              <img
                src={`${process.env.PUBLIC_URL}/svg/throoLogo.svg`}
                alt="스루아이콘"
                style={{
                  width: "118px",
                }}
              />
              <h1>와 동기화 가능</h1>
            </div>

            <h2>
              BEHIND 주문 뿐만 아니라,
              <br />
              스루 주문도 동시에 받으실 수 있습니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKdsImage05.png"
              alt="스루와 연동가능한 비하인드 KDS"
              className="webKds05"
            />
          </div>
          <div className="content">
            <h1
              ref={hideRefs[4]}
              className={` ${isVisible[4] ? "in_view fade_up" : "fade_up"}`}
            >
              단골이 늘어나는 고객 마케팅
            </h1>
            <h2>
              매장에 이벤트가 있거나 고객이 포인트를 적립하면
              <br />
              카카오톡 알림톡이 발송됩니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage05.png"
              alt="고객마케팅이 가능해 단골을 사로잡을 수 있는 KDS"
              className="webKds06"
            />
          </div>
        </div>
        <div className="footerContent">
          <h4>안드로이드 포스가 없으신가요?</h4>
          <h3
            ref={hideRefs[5]}
            className={` ${isVisible[5] ? "in_view fade_in" : "fade_in"}`}
          >
            지금 바로 구매하세요!
          </h3>
          <button>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage06.png"
              alt="비하인드 Kds"
              className="webKds07"
            />
          </button>
        </div>
      </div>
    </Style>
  );
};

export default ServiceKdsPage;
const Style = styled.div`
  h1,
  h2,
  h3,
  h4 {
    text-align: center;
  }
  h1 {
    font-size: 36px;
    font-weight: 700;
    line-height: 50px;
    color: #333;
  }
  h2 {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    color: #979797;
  }
  h3 {
    font-size: 68px;
    font-weight: 700;
    line-height: 95px;
  }
  h4 {
    font-size: 36px;
    font-weight: 500;
    color: #979797;
    line-height: 50px;
  }

  /* wrap */
  .wrap {
    width: 100%;
    max-width: 100%;
    margin-top: 100px;

    img {
      width: 100%;
    }
  }

  /* banner */
  .banner {
    width: 100%;
    position: relative;

    .behindKds {
      position: absolute;
      width: 42%;
      max-width: 769px;
      top: 8%;
      right: 14%;
    }
  }

  /* contentWrap */
  .contentWrap {
    width: 100%;
    padding: 60px 30%;

    .content {
      padding: 120px 0;

      h1 {
        margin-bottom: 32px;
      }
      img {
        margin-top: 50px;
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;

    h1,
    img {
      margin: 0 !important;
    }
  }

  /* footerContent */
  .footerContent {
    text-align: center;
    h3 {
      display: inline-flex;
      padding: 20px 0 60px 0;
      background: linear-gradient(90deg, #4dd2ae 0%, #5096ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
    h4 {
      margin-top: 60px;
    }
  }

  @media (max-width: 1100px) {
    h1 {
      font-size: 28px;
      font-weight: 700;
    }
    h2 {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
    h3 {
      font-size: 32px;
      line-height: 44px;
    }
    h4 {
      font-size: 18px;
      line-height: 25px;
    }
    .wrap {
      margin-top: 70px;
    }
    .bannerTitle {
      h1 {
        font-size: 70px;
        line-height: 48px;
      }
      h2 {
        margin: 30px 0 40px 0;
        font-size: 16px;
        line-height: 25px;
      }
    }
    .contentWrap {
      padding: 40px 5vw;

      .content {
        padding: 40px 0;

        h1 {
          margin-bottom: 12px;
        }

        img {
          margin-top: 30px;
        }
      }
      .content:nth-child(1) {
        h2 {
          padding: 0 5%;
          word-break: keep-all;
        }
      }
    }
    .footerContent {
      h3 {
        padding: 7px 5vw 30px 5vw;
      }
      h4 {
        margin-top: 0;
      }
    }

    /* 이미지 변경 */
    .webKds01 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileKdsImage01.png");
    }
    .webKds06 {
      padding: 5vw;
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileKdsImage02.png");
    }
    .webKds07 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobilePosImage02.png");
    }
  }
`;
